// extracted by mini-css-extract-plugin
module.exports = {"container":"Movies_container__2Nycc","row":"Movies_row__3_C_I","moviesContainer":"Movies_moviesContainer__ATrkh"};